module.exports = __webpack_public_path__ + "static/media/up.aefd0937.mp3";